type Args = {
  url: string;
  appUrl: string;
};

export function isomorphicIsExternalUrl({ url, appUrl }: Args) {
  if (!url) return false;

  // ignore mailto
  if (url.startsWith('mailto:')) {
    return false;
  }

  // links starting with `/` are relative to our website
  if (url.startsWith('/')) return false;

  // links that are relative to the current url, like anchors, query params
  if (url.startsWith('#') || url.startsWith('?')) {
    return false;
  }

  const domain = (u: string) =>
    u.replace('http://', '').replace('https://', '').split('/')[0];

  return Boolean(domain(url)) && domain(url) !== domain(appUrl);
}
